/**
 * Route base paths for the two app areas.
 * - App: public landing/intro pages (/, /hakkimizda, etc.)
 * - Panel: authenticated dashboard (applications, jobs, secrets, dev tools)
 */
export const PANEL_BASE = '/panel';

export const panelPath = (path: string) =>
  path.startsWith('/') ? `${PANEL_BASE}${path}` : `${PANEL_BASE}/${path}`;

/**
 * Parent panel route for in-page back navigation (menu hierarchy, not browser history).
 * Returns null when the path is already a top-level panel page.
 */
export function getParentPanelPath(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, '') || '/';

  const jobDetail = path.match(/^\/panel\/jobs\/([^/]+)$/);
  if (jobDetail) return panelPath('/jobs');

  const publisherDetail = path.match(/^\/panel\/publishers\/([^/]+)$/);
  if (publisherDetail) return panelPath('/publishers');

  const appDetail = path.match(/^\/panel\/applications\/([^/]+)$/);
  if (appDetail) return panelPath('/applications');

  const appNested = path.match(/^\/panel\/applications\/([^/]+)\/.+/);
  if (appNested) return panelPath(`/applications/${appNested[1]}`);

  const systemSub = path.match(/^\/panel\/system-details\/(.+)$/);
  if (systemSub && systemSub[1] !== 'overview') {
    return panelPath('/system-details/overview');
  }

  if (path === panelPath('/profile') || path === panelPath('/upgrade')) {
    return PANEL_BASE;
  }

  return null;
}
